import React, { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Topbar from "../../components/Topbar/Topbar";
import DragAndDrop from "../../components/Property/DragAndDrop";
import Slot from "../../components/OverallProperties/RoomBooking/Slot";
import SpecialDate from "../../components/OverallProperties/RoomBooking/SpecialDate";
import { get, patch, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { dummyimage } from "../../assets/img";

const RoomBookingView = () => {
  const CDN_URL = "https://devcdn.ninositsolution.com/";
  const isUploading = useRef(false);
  const location = useLocation();
  let {
    type,
    property_id,
    service_id,
    selectedCategories,
    data: propData,
    room_id: roomId,
    use_time_slot,
  } = location?.state ?? {};

  // console.log("location?.state", location?.state);
  console.log("propData", propData);
  console.log("use_time_slot", use_time_slot);

  const imgRef = useRef(null);

  const prefillSlots = propData?.time_slots;
  console.log("prefillSlots", prefillSlots);

  const [room_id, setRoom_id] = useState(roomId);
  const editable = type !== "view";
  const [draggableImages, setDraggableImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [tabs, setTabs] = useState(0);
  const [tabsData, setTabsData] = useState({ slot: {}, specialDates: [] });
  const [optionsList, setOptionsList] = useState({
    roomcategories: [],
    amenities: [],
  });
  const [formData, setFormData] = useState({
    roomcategory: "",
    amenities: [],
    totalRoom: "",
    minPerson: "",
    maxPerson: "",
    minChild: "",
    maxChild: "",
  });
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#F4F4F4",
      borderColor: state.isFocused ? "#333" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 1px #333" : "none",
      "&:hover": {
        borderColor: "#333",
      },
    }),
  };

  useEffect(() => {
    getcategoriesList(1);
    getcategoriesList(10);
  }, []);

  useEffect(() => {
    if (room_id) {
      viewRoomDetails();
    } else {
      if (type === "add") return;
      let {
        room_default_image,
        room_category_name,
        room_multiple_images,
        room_type,
        rooms_count,
      } = propData ?? {};
      setFormData((prev) => ({
        ...prev,
        roomcategory: { label: room_category_name, value: room_type },
        totalRoom: rooms_count,
      }));
      let formatImg = room_multiple_images?.map((i) => ({
        image: i,
      }));
      setDraggableImages(formatImg);
      setMainImage(room_default_image);
    }
  }, [room_id]);

  const viewRoomDetails = async (id = room_id) => {
    const res = await get(`${URLS.MASTER_ROOM_BOOKING}${id}/`);
    console.log("view room booking", res);
    if (res?.status === "success") {
      let {
        id,
        amenities,
        images,
        max_child,
        max_person,
        min_child,
        min_person,
        room_category,
        room_category_name,
        total_rooms,
        default_image,
      } = res?.data;
      setRoom_id(id);
      setMainImage(default_image);
      setFormData({
        amenities: amenities?.map((item) => ({
          value: item?.id,
          label: item?.amenity_name,
          ...item,
        })),
        maxChild: max_child,
        maxPerson: max_person,
        minChild: min_child,
        minPerson: min_person,
        roomcategory: { value: room_category, label: room_category_name },
        totalRoom: total_rooms,
      });
      let formatterImages = images?.map((img) => ({
        ...img,
        image: img?.image_name,
      }));
      setDraggableImages(formatterImages);
    }
  };

  const getcategoriesList = async (category_id) => {
    const res = await get(`${URLS.MASTER_DROPDOWN_URL}?type=${category_id}`);
    console.log("categories List", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name, ...item };
      });
      setOptionsList((prev) => ({
        ...prev,
        [category_id === 1 ? "amenities" : "roomcategories"]: modifiedList,
      }));
    }
  };

  const stripCdn = (url) =>
    typeof url === "string" ? url.replace(CDN_URL, "") : url;

  const handleSubmit = async () => {
    if (isUploading.current) return;
    isUploading.current = true;

    if (!formData.roomcategory) {
      toast.error("Room Categories is required");
      isUploading.current = false;
      return;
    }
    if (!formData.totalRoom) {
      toast.error("Total Room is required");
      isUploading.current = false;
      return;
    }

    // Updated: Minimum Person validation (Must be at least 2)
    if (!formData.minPerson || Number(formData.minPerson) < 2) {
      toast.error("Minimum Person must be at least 2");
      isUploading.current = false;
      return;
    }

    // Updated: Minimum Child validation (Must be at least 1)
    if (!formData.minChild || Number(formData.minChild) < 1) {
      toast.error("Minimum Child must be at least 1");
      isUploading.current = false;
      return;
    }

    if (!mainImage) {
      toast.error("Please upload the Room main image");
      isUploading.current = false;
      return;
    }

    if (draggableImages.length === 0) {
      toast.error("Please upload at least one Room image");
      isUploading.current = false;
      return;
    }
    if (formData.amenities.length === 0) {
      toast.error("Amenities is required");
      isUploading.current = false;
      return;
    }

    const {
      amenities,
      maxChild,
      maxPerson,
      minChild,
      minPerson,
      roomcategory,
      totalRoom,
    } = formData;

    let payload = new FormData();

    payload.append("property", property_id);
    if (!room_id) payload.append("service", service_id);
    payload.append("room_category", roomcategory?.value);
    payload.append("total_rooms", totalRoom);
    payload.append("min_person", minPerson);
    payload.append("max_person", maxPerson ? maxPerson : 0);
    payload.append("min_child", minChild);
    payload.append("max_child", maxChild ? maxChild : 0);
    payload.append(
      "amenities",
      amenities.map((item) => item.value),
    );
    payload.append("deleted_image_ids", deletedImages);

    if (room_id) {
      payload.append("room_default_image", mainImage ?? "");
      draggableImages?.forEach((img, ind) => {
        if (img?.id) {
          payload.append("room_images_id", img.id);
          payload.append("room_images_position", ind + 1);
        } else {
          payload.append("room_images", img.image);
          payload.append("new_room_images_position", ind + 1);
        }
      });
    } else {
      payload.append("room_default_image", stripCdn(mainImage));
      draggableImages?.forEach((img) => {
        if (typeof img.image === "string") {
          payload.append("room_existing_images", stripCdn(img.image));
        } else {
          payload.append("room_images", img.image);
        }
      });
    }

    let method = room_id ? patch : post;
    const res = await method(
      `${URLS.MASTER_ROOM_BOOKING}${room_id ? "edit/" + room_id : "add"}/`,
      payload,
    );

    console.log("create booking ", res);
    if (res?.status === "success") {
      isUploading.current = false;

      if (room_id) {
        viewRoomDetails(room_id);
      } else {
        const newId = res?.data?.[0]?.id;
        setRoom_id(newId);
      }
    } else {
      // Always make sure to release the lock if an error happens from the API
      isUploading.current = false;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTagsChange = (selectedOptions, name) => {
    setFormData((prev) => ({ ...prev, [name]: selectedOptions }));
  };
  console.log("min max", formData);
  const filterOptions = (options, selectedList) => {
    // eslint-disable-next-line array-callback-return
    let filtered = options?.filter((item) => {
      let finded = selectedList?.find((s) => s.value == item?.value);
      if (!finded) return true;
    });
    return filtered;
  };

  // Custom Option with Radio Button
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div className="d-flex ac-jb">
          <label>{props.label}</label>
          <span
            style={{
              height: "16px",
              width: "16px",
              borderRadius: "50%",
              border: "2px solid #9A36E6",
              display: "inline-block",
              position: "relative",
            }}
          >
            {props.isSelected && (
              <span
                style={{
                  height: "8px",
                  width: "8px",
                  backgroundColor: "#9A36E6",
                  borderRadius: "50%",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            )}
          </span>
        </div>
      </components.Option>
    );
  };

  const handleRemove = (value) => {
    setFormData((prev) => ({
      ...prev,
      amenities: prev.amenities?.filter((item) => item.value !== value),
    }));
  };
  console.log("form data", formData);
  const CustomMultiValue = () => null;

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMainImage(file);
    }
  };

  return (
    <div onWheel={(e) => e.target.blur()}>
      <Topbar
        header={`Room Booking ${
          type === "add" ? "Add" : type === "edit" ? "Edit" : "View"
        }`}
        subHead={"Live Approval"}
      />
      <div className="d-flex flex-wrap gap-5 mt-4 col-md-12">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Room Categories
          </p>
          <Select
            isDisabled={!editable || propData?.room_type}
            options={filterOptions(
              optionsList.roomcategories,
              selectedCategories,
            )}
            value={formData?.roomcategory}
            onChange={(e) => handleTagsChange(e, "roomcategory")}
            placeholder="Select Room Categories"
            styles={customStyles}
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Total Room
          </p>
          <input
            className="input-box"
            name="totalRoom"
            value={formData?.totalRoom}
            disabled={type === "view"}
            onChange={handleChange}
            type="number"
            placeholder="Total Room"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Minimum Person (At least 2 required)
          </p>
          <input
            className="input-box"
            name="minPerson"
            value={formData?.minPerson}
            disabled={type === "view"}
            onChange={handleChange}
            type="number"
            placeholder="Minimum Person"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Maximum Person
          </p>
          <input
            className="input-box"
            name="maxPerson"
            value={formData?.maxPerson}
            disabled={type === "view"}
            onChange={handleChange}
            type="number"
            placeholder="Maximum Person"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Minimum Child (At least 1 required)
          </p>
          <input
            className="input-box"
            name="minChild"
            value={formData?.minChild}
            disabled={type === "view"}
            onChange={handleChange}
            type="number"
            placeholder="Minimum Child"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Maximum Child
          </p>
          <input
            className="input-box"
            name="maxChild"
            value={formData?.maxChild}
            disabled={type === "view"}
            onChange={handleChange}
            type="number"
            placeholder="Maximum Child"
          />
        </div>
      </div>

      <div className="col-md-5 my-3">
        <div>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            Room Main Image<span style={{ color: "red" }}>*</span>
          </p>

          <div>
            {mainImage ? (
              <div style={{ position: "relative", width: "100px" }}>
                <img
                  src={
                    mainImage instanceof File
                      ? URL.createObjectURL(mainImage)
                      : mainImage
                  }
                  style={{
                    width: "100px",
                    height: "90px",
                    marginTop: 10,
                    cursor: "pointer",
                  }}
                  alt=""
                />
                <button
                  onClick={() => setMainImage(null)}
                  style={{
                    position: "absolute",
                    top: 0,
                    right: -10,
                    background: "red",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: 19,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 20,
                    height: 20,
                  }}
                >
                  X
                </button>
              </div>
            ) : (
              <div>
                <img
                  src={dummyimage}
                  style={{
                    width: "100px",
                    height: "90px",
                    marginTop: 10,
                    cursor: "pointer",
                    // objectFit: "contain",
                  }}
                  alt=""
                  onClick={() => imgRef.current?.click()}
                />
                <input
                  type="file"
                  className="input-pop mt-2 w-100 d-none"
                  accept="image/*"
                  onChange={(e) => handleImageChange(e)}
                  ref={imgRef}
                />
              </div>
            )}{" "}
          </div>
        </div>
      </div>
      <div className="my-4">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
          Room Image<span style={{ color: "red" }}>*</span>
        </p>
        <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mb-1 red">
          Max Upload Size : 5MB
        </p>
        <DragAndDrop
          edit={editable}
          draggableImages={draggableImages}
          setDraggableImages={setDraggableImages}
          setDeletedImages={setDeletedImages}
        />
      </div>
      <div className="w-90">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
          Amenities
        </p>
        {formData.amenities?.length > 0 && (
          <div className="d-flex flex-wrap ac-js gap-2 mt-2 mb-2 ">
            {formData.amenities.map((person) => (
              <div
                key={person.value}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "6px",
                  padding: "6px 10px",
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                }}
              >
                <img
                  className="me-2"
                  alt={person.label}
                  src={person.icon}
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "100%",
                  }}
                />
                <span>{person.label}</span>
                <div className="ms-3">
                  {/* <span className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 me-3 sec">
                    ID: {person.id}
                  </span> */}
                  <button
                    onClick={() => handleRemove(person.value)}
                    style={{
                      marginLeft: "auto",
                      height: "16px",
                      width: "16px",
                      borderRadius: "50%",
                      border: "2px solid #9A36E6",
                      display: "inline-block",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        height: "8px",
                        width: "8px",
                        backgroundColor: "#9A36E6",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        <Select
          isDisabled={type === "view"}
          value={formData.amenities} // now stores array of selected options
          options={optionsList.amenities}
          onChange={(e) => {
            handleTagsChange(e, "amenities");
          }}
          name="amenities"
          placeholder="Amenities"
          isMulti
          isSearchable
          isClearable={false}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CustomOption,
            MultiValue: CustomMultiValue, // hides inside select
          }}
          styles={{
            control: (base) => ({
              ...base,
              borderColor: "#ccc",
              minHeight: "40px",
            }),
          }}
        />
      </div>
      {type !== "view" && (
        <div className="d-flex ac-je mt-5">
          <button
            onClick={handleSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          >
            Submit
          </button>
        </div>
      )}
      <div>
        <div className="d-flex ac-js gap-4 mt-4">
          <p
            onClick={() => {
              if (!room_id) {
                toast.error(
                  "Please fill out the remaining required fields. Once submitted, you will be able to access the slot.",
                );
                return;
              } else {
                setTabs(1);
              }
            }}
            className={`${
              tabs === 1 ? "prim-btn" : "sec"
            } f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 pointer`}
          >
            {" "}
            Slot
          </p>

          <p
            onClick={() => {
              if (!room_id) {
                toast.error(
                  "Please fill out the remaining required fields. Once submitted, you will be able to access the slot.",
                );
                return;
              } else {
                setTabs(2);
              }
            }}
            className={`${
              tabs === 2 ? "prim-btn" : "sec"
            } f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20   pointer`}
          >
            Special Date
          </p>
        </div>

        {tabs === 1 && (
          <Slot
            viewOnly={type === "view"}
            property_id={property_id}
            room_id={room_id}
            tabsData={tabsData}
            setTabsData={setTabsData}
            prefillSlots={use_time_slot ? prefillSlots : null}
          />
        )}
        {tabs === 2 && (
          <SpecialDate
            tabsData={tabsData}
            setTabsData={setTabsData}
            property_id={property_id}
            room_id={room_id}
            viewOnly={type === "view"}
          />
        )}
      </div>
    </div>
  );
};

export default RoomBookingView;
